// @flow
import { createReducer } from "state/utils";
import * as workspacesTypes from "state/ducks/workspaces/types";
import * as uiTypes from "./types";

/**
 * The form state will go through a cycle:
 *     initial -> requesting -> [completed|failed]
 *     initial:             initial state of the form, you can click on the submit button
 *     requesting:          submit button has been clicked and request is in progress
 *     [completed|failed]:  the request has either completed or failed
 *
 * The errorFields will contain the list of fields that have issues
 * The message field will contain the error message
 * Message type is used to display a warning or error message
 */

const INITIAL_STATE = {
  errorFields: {},
  isCancelingSubscription: false,
  formState: "pending",
  message: "",
  messageType: "warning"
};

export default createReducer(INITIAL_STATE)({
  [workspacesTypes.CANCEL_SUBSCRIPTION_REQUESTED]: (state, action) => {
    return {
      ...state,
      isCancelingSubscription: true,
      formState: "requesting",
      message: "",
      messageType: "warning"
    };
  },
  [workspacesTypes.CANCEL_SUBSCRIPTION_COMPLETED]: (state, action) => {
    let message = "Your subscription has been canceled.";
    return {
      ...state,
      isCancelingSubscription: false,
      formState: "completed",
      message: message,
      messageType: "success"
    };
  },
  [workspacesTypes.CANCEL_SUBSCRIPTION_FAILED]: (state, action) => {
    return {
      ...state,
      isCancelingSubscription: false,
      formState: "failed",
      message: "Sorry but we could not cancel your subscription",
      messageType: "warning"
    };
  },
  [uiTypes.CLEAR_PAGE]: () => INITIAL_STATE
});
